import React from "react"
import {Grid, Stack} from "@mui/material";
import {formatTime} from "@/helper/method";
import {GridItem} from "@/widget/GridItem/GridItem";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import isEmpty from "lodash/isEmpty";
import {useQueryAccepting, AcceptingVO} from "@/service/accepting.s";
import Typography from "@mui/material/Typography";
import {reviewStatus} from "@/helper/constant";
import {isNumber} from "lodash";
import {useDrawerModal} from "@/store/global.c";

export const ViewAccepting = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: acceptingData, isLoading: acceptingLoading} = useQueryAccepting({id: drawerId!}, isNumber(drawerId))
    const accepting = acceptingData?.data || {} as AcceptingVO
    const {task, plan, review, ...rest} = accepting

    return <ResultWrapper isLoading={acceptingLoading} isEmpty={isEmpty(accepting)}>
        <Stack direction="column" gap={1.5}>
            <Typography variant={"h6"} fontSize={16} fontWeight={500}>任务验收</Typography>
            <Grid
                spacing={3}
                container
            >
                <GridItem title={'目标计划'} content={plan?.planName}/>
                <GridItem title={'任务名称'} content={task?.taskName}/>
                <GridItem title={'任务属性'} content={task?.virtue}/>
                <GridItem title={'当前负责人'} content={plan?.executor}/>
                <GridItem title={'所属目标阶段'} content={task?.planStage}/>
                <GridItem title={'优先级'} content={task?.priority}/>
                <GridItem title={'所属里程碑任务'} content={"-"}/>
                <GridItem title={'预计工时'} content={task?.duration}/>
                <GridItem title={'开始时间'} content={formatTime("D", task?.startTime)}/>
                <GridItem title={'截止时间'} content={formatTime("D", task?.endTime)}/>
                <GridItem minHeight={'80px'} size={12} title={'任务描述'} content={task?.description || '-'}/>

                <GridItem title={'创建人'} content={rest?.creator}/>
                <GridItem title={'实际完成时间'} content={formatTime("D", rest?.finishTime)}/>
                <GridItem title={'创建时间'} content={formatTime("D", rest?.createdAt)}/>
                <GridItem title={'更新时间'} content={formatTime("D", rest?.updatedAt)}/>
                <GridItem minHeight={'80px'} size={12} title={'验收说明'} content={rest?.description || '-'}/>
            </Grid>
            <Typography variant={"h6"} fontSize={16} fontWeight={500}>审核信息</Typography>
            <Grid
                spacing={3}
                container
            >
                <GridItem title={'审核结果'} content={reviewStatus[review?.status]}/>
                <GridItem title={'审核时间'} content={review?.reviewAt && formatTime("D", review?.reviewAt) || '-'}/>
                <GridItem minHeight={'80px'} size={12} title={'审核意见'} content={review?.opinion || '-'}/>

            </Grid>
        </Stack>

    </ResultWrapper>
};
